<template>
	<div id="personal">
		<div class="container">
			<div class="float-left">
				<div class="width300">
					<div class=" float-left"><img style="border-radius:50%" :src="picture" width="100" height="100"></div>
					<div class=" float-left g-tit">
						<h3>{{username}}</h3>
						<h4>认证状态:
							<Icon type="logo-vimeo" /><span @click='authen' class='authen'>{{card}}</span></h4>

					</div>
					<div class=" clearfix"></div>
					<div class="g-sf">
						所属身份 | {{indentity}}
					</div>
					<div class="g-edit-btn">
						<router-link class="edit_per" to='/per_admin/edit/jbxx'>编辑个人资料</router-link>
						<router-link class="perinfor" to='/per_admin/perinfor'>个人后台</router-link>
					</div>

				</div>
				<div class="g-left-middle width300 ">
					<router-link to='/per_admin/received'>
						<p>我的报名</p>
					</router-link>
					<router-link to='/per_admin/collect/jzcollect'>
						<p>我的收藏</p>
					</router-link>
					<router-link to='/per_admin/change/changeinfo'>
						<p>修改信息</p>
					</router-link>
					<router-link to='/per_admin/authen'>
						<p>在线认证</p>
					</router-link>
					<router-link to='/per_admin/bind'>
						<p>绑定账号</p>
					</router-link>
					<router-link to='/per_admin/feedback'>
						<p>意见反馈</p>
					</router-link>
				</div>
				<div class="g-left-bottom width300">
					<div class="g-sf">
						zuikanyusheng@126.com
					</div>
					<div class="g-edit-btn">联系我们</div>
				</div>
			</div>
			<div class="float-right">

				<router-view></router-view>
			</div>
			<div class=" clearfix"></div>



		</div>
	</div>
</template>

<script>
	import storage from '../../storage/storage.js'
	import Axios from 'axios'
	export default {
		data() {
			return {
				username: storage.get('username'),
				picture:storage.get('picture'),
				indentity: '',
				card:'',

				}

		},
		methods:{
			authen(){
				this.$router.push('/per_admin/authen')
			},

		},

		mounted() {
			var token=storage.get('token')
			if(token==null){
				this.$router.push('/')
			}
			var userdata=storage.get('userdata')
			if(userdata!=null){
				$('.edit_per').hide()

			}else{
				$('.perinfor').hide()
			}
			//认证信息判断
			var card=storage.get('card')
			if(card=='1'){
				this.card='未认证'
				$(function(){
					$('.ivu-icon-logo-vimeo').css('color',"grey");
				})
			}
			if(card=='2'){
				this.card='审核中'
				$(function(){
					$('.authen').attr('disabled',"true");//jq方法禁用认证弹窗
					$('.ivu-icon-logo-vimeo').css('color',"#ff5a61");
				})
			}
			if(card=='3'){
				this.card='已认证'
				$(function(){
					$('.authen').attr('disabled',"true");//jq方法禁用认证弹窗
					$('.ivu-icon-logo-vimeo').css('color',"#c8b9a6");
				})
			}





				var iden = storage.get('iden')
				if (iden == '1') {
					var identity = '艺人'
					this.indentity = identity
				}
				if (iden == '3') {
					var identity = '经纪人'
					this.indentity = identity
				}



		}

	}
</script>
<style>
	#personal {
		background: #e3e3e3;
	}

	.g-sf {
		padding: 14px 0;
		text-align: center;
		border-top: 1px solid #C8B9A6;
		border-bottom: 1px solid #C8B9A6;

		margin: 20px auto;
	}

	.width300 {
		width: 300px;
		background: #fff;
		padding: 20px;
	}

	.g-tit {
		margin-top: 30px;
		margin-left: 30px;
	}

	.g-edit-btn a,
	.g-edit-btn {
		width: 300px !important;
		display: block;
		height: 40px;
		background: #C8B9A6;
		text-align: center;
		line-height: 40px;
		color: #fff;
		margin: 40px auto 10px auto;
		font-size: 18px;

	}

	.g-left-middle {
		margin: 20px auto;

	}

	.g-left-middle p {
		text-align: center;
		padding: 6px 0;
		line-height: 30px;
		font-size: 16px;
		border-bottom: 1px solid #e6e6e6;
	}

	.g-left-middle p:hover {
		font-weight: 900;
		cursor: pointer;
		background: #C8B9A6;
		text-align: center;
		transition: 0.1s;
		color: #fff;
		font-size: 18px;

	}

	.g-left-middle a {
		color: #555;
	}

	.width800 {
		width: 800px;
		background: #fff;
	}

	.g-right-top,
	.g-right-middle {
		padding: 20px;
	}

	.margintop20 {
		margin-top: 20px;
	}



	.g-add-btn {
		width: 230px;
		height: 40px;
		background: #f25851;
		text-align: center;
		line-height: 40px;
		color: #fff;
		font-size: 16px;
		cursor: pointer;
		font-weight: 900;
		margin: 50px auto;
		margin-bottom: 160px;
	}

	.g-btn {
		width: 200px;
		height: 40px;
		line-height: 40px;
		color: #fff;
		background: #f25851;
		text-align: center;
		border: none;
		margin: 40px auto;
	}
</style>



// WEBPACK FOOTER //
// src/components/per_admin/Personal.vue